import Head from "next/head";
import { Layout } from "../../../../components/Layout";
import { LayoutAdmin } from "../../../../components/LayoutAdmin"
import { Duvidas } from "../../../../components/Duvidas";

const ConfigurarMercadoPago = () => {
    return (
        <Layout>
            <>
            <Duvidas />
                <Head>
                    <title>Rifaweb | Configure o Mercado Pago</title>
                </Head>
                <div className="container p-5 text-black">
                    <div className="flex flex-col max-w-4xl">
                        <h2>Como adicionar o Mercado Pago como forma de pagamento</h2>
                        <hr />
                        <ol className="list-decimal">
                            <li>
                                <p>Crie uma aplicação no Mercado Pago, acesse a página para criar clicando <a href="https://mercadopago.com.br/developers/panel/credentials" target="_blank" rel="noopener noreferrer nofollow">aqui</a>.</p>
                            </li>
                        </ol>
                        <ul className="list-disc">
                            <li><p>Em <strong>nome</strong> você irá inserir qualquer nome para você poder identificar a aplicação.</p></li>
                            <li><p>Em <strong>produto</strong> a ser integrado você irá inserir <strong>&quot;Checkout Transparente&quot;</strong>.</p></li>
                        </ul>
                        <p className="">
                            <a href="/imagensMercadoPago/como-criar-aplicacao-mercado-pago.png" target="_blank">
                                <img className="w-1/2" src="/imagensMercadoPago/como-criar-aplicacao-mercado-pago.png" alt="" />
                            </a>
                        </p>
                        <hr />
                        <ol className="list-decimal mt-3" start={2}>
                            <li><p>Com a aplicação do Mercado Pago já criada, você irá clicar no botão em laranja <strong>&quot;Ativar credenciais&quot;</strong>, e irá preencher o formulário.</p></li>
                        </ol>
                        <p className="">
                            <a href="/imagensMercadoPago/ativar-credenciais-mercado-pago.png" target="_blank">
                                <img className="w-1/2" src="/imagensMercadoPago/ativar-credenciais-mercado-pago.png" alt="" />
                            </a>
                        </p>
                        <ul className="list-disc">
                            <li><p>Em <strong>site</strong> você pode deixar o campo em branco ou inserir o link da sua campanha.</p></li>
                            <li><p>Em <strong>indústria</strong> você insere o que mais se adequada com sua campanha.</p></li>
                        </ul>
                        <hr />
                        <p className="">
                            <a href="/imagensMercadoPago/ativando-credenciais-mercado-pago.png" target="_blank">
                                <img className="w-1/2" src="/imagensMercadoPago/ativando-credenciais-mercado-pago.png" alt="" />
                            </a>
                        </p>
                        <ol className="list-decimal" start={3}>
                            <li><p>Após preencher o formulário e clicar em <strong>&quot;Enviar formulário&quot;</strong>, você irá acessar as <strong>credenciais de produção</strong>.</p></li>
                            <li><p>Você irá copiar o <strong>&quot;Access Token&quot;</strong> clicando no botão de copiar em azul à direita, e cola no campo do Mercado Pago no painel administrativo da Rifaweb.</p></li>
                        </ol>

                        <hr />
                        <p className="">
                            <a href="/imagensMercadoPago/credenciais-de-producao-mercado-pago.png" target="_blank">
                                <img className="w-1/2" src="/imagensMercadoPago/credenciais-de-producao-mercado-pago.png" alt="" />
                            </a>
                        </p>
                        <p>
                            <em>
                                Para adicionar o Mercado Pago na sua campanha, é necessário ter uma conta criada no Mercado Pago,
                                caso não tenha, crie uma conta primeiro e depois siga os passos deste artigo.
                            </em>
                        </p>

                    </div>
                </div>
            </>
        </Layout>
    )
}

export default ConfigurarMercadoPago;